<template>
  <div class="main-mobile-footer__item" @click="handleOpen">
    <TreeIcon class="main-mobile-footer-icon" aria-hidden="true" />
    <span class="main-mobile-footer-caption">{{ t('All clients') }}</span>
  </div>
</template>

<script setup lang="ts">
import { markRaw } from 'vue'

import { useLocale } from '@/plugins/i18n'

import { useModalsStore } from '@/store/modals'

import TreeIcon from '@/assets/images/icons/tree.svg'
import AdvisorMobileTreeDrawer from './AdvisorMobileTreeDrawer.vue'

const { t } = useLocale('layouts.Main')

const modalsStore = useModalsStore()

const handleOpen = () => {
  const modalInstance = modalsStore.init(
    'mobile-footer-clients',
    markRaw(AdvisorMobileTreeDrawer),
  )
  modalInstance?.open(modalsStore.getZIndex())
}
</script>
